<template>
  <a :href="idOrg" target="_blank" class="c-dialog-head__link">
    <el-button
      v-if="isSmallButton"
      class="c-dialog-head__btn"
      type="success"
      icon="el-icon-copy-document"
      circle
      title="Скопировать ссылку на профиль"
    />
    <el-button
      v-else
      class="c-dialog-head__btn"
      type="success"
      icon="el-icon-copy-document"
      title="Скопировать ссылку на профиль"
    >
      Скопировать ссылку на профиль
    </el-button>
  </a>
</template>
<script>
export default {
  name: 'ShareLinkButton',
  props: {
    idOrg: {
      type: Number,
      default: 0,
    },
    isSmallButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.c-dialog-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 20px;

  &__title {
    margin: 0;
  }

  &__link {
  }

  &__btn {
  }
}
</style>
